import React from 'react';
import PropTypes from 'prop-types';
import { OptionsPropType } from 'utils/propTypes';
import RadioGroup from 'components/base/radioGroup/RadioGroup';

const RadioGroupBoolean = (props) => {
  return <RadioGroup className="radioGroup--boolean" {...props} />;
};

RadioGroupBoolean.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: OptionsPropType,
  className: PropTypes.string,
  value: PropTypes.string,
  fieldRef: PropTypes.shape({}),
};

export default RadioGroupBoolean;
